import Vue from 'vue'
import Vuex from 'vuex'
import { nselection, salon, leaders, keepgoing } from './modules';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    nselection,
    salon,
    leaders,
    keepgoing
  },
  state: {
    // 推奨商品・定期購入誘導用
    recommendation: {
      recommendProductMap: {},     // APIから取得した推奨商品マップ
      simulationResult: null,       // シミュレーション結果
      multiBcOrderData: {},         // 複数BC注文データ
      purchaseSettings: {           // 購入注文から取得した設定値
        deliveryTimeId: null,
        paymentMethodId: null,
        timestamp: null
      }
    },
    bank: {
      branchList: [],
    },
    purchase: {
      cartCount: 0,
      nowBC: '',
      cartBC: '',
      birthMonthDiscountPrice: 0, // 確認完了画面で使用している
      cashOnDeliveryFee: 0,
      couponDiscount: 0,
      shipmentFee: 0,
      useBirthMonthDiscount: false,
      currentOrderMonth: 0,
      totalPrice: 0,
      totalPoint: 0,
      wallet: {
        useBirthMonthDiscount: false,
        birthMonthDiscountPrice: 0,
        walletAmount: null,
        useWallet: 0, // 使用するウォレット
        usePurchasePoint: 0, // 使用するお買い物ポイント
        bcShipmentFeeList: [],
        selectWalletType: 'NO_USE',
        inputWallet: 0,
        shipmentFee: 0,
        useWalletBillAmount: 0,
      }
    },
    subscription: {
      nowBC: '',
      checkSelectRepeatOrder: true,

      sameWithBc001CreditCardId: 0,
      sameWithBc001CardBrand: '',
      sameWithBc001CardNo: '',
      sameWithBc001ExpireYearMonth: '',
      sameWithBc001Expired: '',
      sameWithBc001HolderName: '',
      sameWithBc001Selected: false,
      sameWithBc001SameWithBc001: false,
      viewSameWithBc001: false,

      deliveryAddress: {
        sameWithBc001RecipientName: '',
        sameWithBc001DeliveryAddressId: '',
        sameWithBc001ZipCode: '',
        sameWithBc001PrefectureName: '',
        sameWithBc001Address: '',
        sameWithBc001: false,
        sameWithBc001Seleced: false,
        viewSameWithBc001: false,
      },
      denyCreditDeliveryFlag: null,
    },

    userDetail: {
      deliveryDate: {
        deliveryDateLabel: "",
        deliveryDateValue: "",
      },
      deliveryTimeData: {
        deliveryTimeId: null,
        deliveryTimeName: '',
      },
      deliveryAddressData: {
        recipientName: '',
        deliveryAddressId: null,
        zipCode: '',
        prefectureName: '',
        address: '',
        sameWithBc001: false,
      },
      paymentData: {
        paymentMethod: '',
        paymentMethodId: 0,
        paymentMethodName: '',
        expireYearMonth: null,
        expired: false,
        selectPaymentCount: 1,
      },
      selectCreditData: {
        cardBrand: '',
        cardNo: '',
        creditCardId: '',
        expireYearMonth: null,
        expired: false,
        holderName: '',
        selected: false,
        sameWithBc001: false,
      },
      couponList: [],
      selectCoupon: {
        name: '',
        use: 0
      },
      availableBulkSetting: false,
    },

    fanClub: {
      redirectUrl: '',
      orderId: '',
      plan: {
        selectPlanId: '',
        selectPlanName: '',
        selectPlanPrice: 0,
      },
      credit: {
        cardNo: '',
        creditCardId: null,
      },
    },

    addCreditCard: {
      reloadCheck: true,
    },
    articleList: {
      articleThumbnailList: [],
      currentPageNo: null,
      hasNext: true,
    },
    tagArticleList: {
      articleThumbnailList: [],
      currentPageNo: null,
      hasNext: true,
    },
    articleResultType: false,
    attentionArticleLists: {},

    wallet: {
      cashFlow: {
        modalShow: false,
        fromDate: null,
        toDate: null,
      },
      withdraw: {
        totalAmount: 0,
        cashAmount: 0,
        withdrawFee: 0,
        withdrawPrice: null,
        isBonus: false,
        bankAccount: null,
        amount: 0,
      },
      salesSummaryReport: {
        currentMonth: null,
      },
    }
  },
  getters: {
    // 推奨商品・定期購入誘導
    recommendationRecommendProductMap: state => state.recommendation.recommendProductMap,
    recommendationSimulationResult: state => state.recommendation.simulationResult,
    recommendationMultiBcOrderData: state => state.recommendation.multiBcOrderData,
    recommendationPurchaseSettings: state => state.recommendation.purchaseSettings,
    
    getBank: state => state.bank,
    bankBranchList: state => state.bank.branchList,
    reloadCheck: state => state.addCreditCard.reloadCheck,
    userDetail: state => state.userDetail,
    userDetailCouponList: state => state.userDetail.couponList,

    /*
    * 購入
    */
    purchaseCartCount: state => state.purchase.cartCount,
    purchaseNowBC: state => state.purchase.nowBC,
    purchaseCartBC: state => state.purchase.cartBC,

    purchaseBirthMonthDiscountPrice: state => state.purchase.birthMonthDiscountPrice,
    purchaseCashOnDeliveryFee: state => state.purchase.cashOnDeliveryFee,
    purchaseCouponDiscount: state => state.purchase.couponDiscount,
    purchaseShipmentFee: state => state.purchase.shipmentFee,
    purchaseUseBirthMonthDiscount: state => state.purchase.useBirthMonthDiscount,
    purchaseCurrentOrderMonth: state => state.purchase.currentOrderMonth,
    purchaseWalletUseBirthMonthDiscount: state => state.purchase.wallet.useBirthMonthDiscount,
    purchaseWalletBirthMonthDiscountPrice: state => state.purchase.wallet.birthMonthDiscountPrice,
    purchaseWalletWalletAmount: state => state.purchase.wallet.walletAmount,
    purchaseWalletUseWallet: state => state.purchase.wallet.useWallet,
    purchaseWalletUsePurchasePoint: state => state.purchase.wallet.usePurchasePoint,

    purchaseWalletBcShipmentFeeList: state => state.purchase.wallet.bcShipmentFeeList,
    purchaseWalletselectWalletType: state => state.purchase.wallet.selectWalletType,
    purchaseWalletInputWallet: state => state.purchase.wallet.inputWallet,
    purchaseWalletShipmentFee: state => state.purchase.wallet.shipmentFee,
    purchaseWalletUseWalletBillAmount: state => state.purchase.wallet.useWalletBillAmount,

    purchaseTotalPrice: state => state.purchase.totalPrice,
    purchaseTotalPoint: state => state.purchase.totalPoint,

    /*
    * 定期購入
    */
    subscriptionNowBC: state => state.subscription.nowBC,
    checkSelectRepeatOrder: state => state.subscription.checkSelectRepeatOrder,

    subscriptionSameWithBc001CreditCardId: state => state.subscription.sameWithBc001CreditCardId,
    subscriptionSameWithBc001CardBrand: state => state.subscription.sameWithBc001CardBrand,
    subscriptionSameWithBc001CardNo: state => state.subscription.sameWithBc001CardNo,
    subscriptionSameWithBc001ExpireYearMonth: state => state.subscription.sameWithBc001ExpireYearMonth,
    subscriptionSameWithBc001Expired: state => state.subscription.sameWithBc001Expired,
    subscriptionSameWithBc001HolderName: state => state.subscription.sameWithBc001HolderName,
    subscriptionSameWithBc001Selected: state => state.subscription.sameWithBc001Selected,
    subscriptionSameWithBc001SameWithBc001: state => state.subscription.sameWithBc001SameWithBc001,

    subscriptionViewSameWithBc001: state => state.subscription.viewSameWithBc001,

    subscriptionDeliveryAddressSameWithBc001RecipientName: state => state.subscription.deliveryAddress.sameWithBc001RecipientName,
    subscriptionDeliveryAddressSameWithBc001DeliveryAddressId: state => state.subscription.deliveryAddress.sameWithBc001DeliveryAddressId,
    subscriptionDeliveryAddressSameWithBc001ZipCode: state => state.subscription.deliveryAddress.sameWithBc001ZipCode,
    subscriptionDeliveryAddressSameWithBc001PrefectureName: state => state.subscription.deliveryAddress.sameWithBc001PrefectureName,
    subscriptionDeliveryAddressSameWithBc001Address: state => state.subscription.deliveryAddress.sameWithBc001Address,
    subscriptionDeliveryAddressSameWithBc001: state => state.subscription.deliveryAddress.sameWithBc001,
    subscriptionDeliveryAddressSameWithBc001Seleced: state => state.subscription.deliveryAddress.sameWithBc001Seleced,

    subscriptionDeliveryAddressViewSameWithBc001: state => state.subscription.deliveryAddress.viewSameWithBc001,
    subscriptionDenyCreditDeliveryFlag: state => state.subscription.denyCreditDeliveryFlag,

    /*
    * ファンクラブ
    */
    fanClubSelectPlanId: state => state.fanClub.plan.selectPlanId,
    fanClubSelectPlanName: state => state.fanClub.plan.selectPlanName,
    fanClubsSelectPlanPrice: state => state.fanClub.plan.selectPlanPrice,
    fanClubCreditId: state => state.fanClub.credit.creditCardId,
    fanClubCreditCardNumber: state => state.fanClub.credit.cardNo,
    fanClubOrderId: state => state.fanClub.orderId,

    /*
    * コラム
    */
    articleList: state => state.articleList,
    tagArticleList: state => state.tagArticleList,
    articleResultType: state => state.articleResultType,
    attentionArticleLists: state => state.attentionArticleLists,

    /*
    * wallet
    */
    cashFlowModal: state => state.wallet.cashFlow.modalShow,
    fromDate: state => state.wallet.cashFlow.fromDate,
    toDate: state => state.wallet.cashFlow.toDate,

    totalAmount: state => state.wallet.withdraw.totalAmount,
    cashAmount: state => state.wallet.withdraw.cashAmount,
    withdrawFee: state => state.wallet.withdraw.withdrawFee,
    withdrawPrice: state => state.wallet.withdraw.withdrawPrice,
    isBonus: state => state.wallet.withdraw.isBonus,
    bankAccount: state => state.wallet.withdraw.bankAccount,
    amount: state => state.wallet.withdraw.amount,

    currentMonth: state => state.wallet.salesSummaryReport.currentMonth
  },
  mutations: {
    // 推奨商品・定期購入誘導
    setRecommendationRecommendProductMap(state, recommendProductMap) {
      state.recommendation.recommendProductMap = recommendProductMap;
    },
    setRecommendationSimulationResult(state, simulationResult) {
      state.recommendation.simulationResult = simulationResult;
    },
    setRecommendationMultiBcOrderData(state, multiBcOrderData) {
      state.recommendation.multiBcOrderData = multiBcOrderData;
    },
    setRecommendationPurchaseSettings(state, purchaseSettings) {
      state.recommendation.purchaseSettings = { ...purchaseSettings };
    },
    
    setBankBranchList(state, branchList) {
      state.bank.branchList.splice(0, state.bank.branchList.length);
      state.bank.branchList.push(...branchList);
    },
    resetCartCount(state, cartCount) {
      state.purchase.cartCount = cartCount;
    },
    addCartCount(state, cartCount) {
      state.purchase.cartCount = state.purchase.cartCount + cartCount;
    },
    subtractCartCount(state, cartCount) {
      state.purchase.cartCount = state.purchase.cartCount - cartCount;
    },
    setPurchaseNowBC(state, nowBC) {
      state.purchase.nowBC = nowBC;
    },
    setPurchaseCartBC(state, cartBC) {
      state.purchase.cartBC = cartBC;
    },
    setPurchaseCurrentOrderMonth(state, currentOrderMonth) {
      state.purchase.currentOrderMonth = currentOrderMonth;
    },

    setPurchaseBirthMonthDiscountPrice(state, birthMonthDiscountPrice) {
      state.purchase.birthMonthDiscountPrice = birthMonthDiscountPrice;
    },
    setPurchaseCashOnDeliveryFee(state, cashOnDeliveryFee) {
      state.purchase.cashOnDeliveryFee = cashOnDeliveryFee;
    },
    setPurchaseCouponDiscount(state, couponDiscount) {
      state.purchase.couponDiscount = couponDiscount;
    },
    setPurchaseShipmentFee(state, shipmentFee) {
      state.purchase.shipmentFee = shipmentFee;
    },
    setPurchaseUseBirthMonthDiscount(state, useBirthMonthDiscount) {
      state.purchase.useBirthMonthDiscount = useBirthMonthDiscount;
    },

    setPurchaseWalletUseBirthMonthDiscount(state, useBirthMonthDiscount) {
      state.purchase.wallet.useBirthMonthDiscount = useBirthMonthDiscount;
    },

    setPurchaseWalletBirthMonthDiscountPrice(state, birthMonthDiscountPrice) {
      state.purchase.wallet.birthMonthDiscountPrice = birthMonthDiscountPrice;
    },


    setPurchaseWalletWalletAmount(state, walletAmount) {
      state.purchase.wallet.walletAmount = walletAmount;
    },

    setPurchaseWalletUseWallet(state, useWallet) {
      state.purchase.wallet.useWallet = useWallet;
    },

    setPurchaseWalletUsePurchasePoint(state, usePurchasePoint) {
      state.purchase.wallet.usePurchasePoint = usePurchasePoint;
    },

    setPurchaseWalletBcShipmentFeeList(state, bcShipmentFeeList) {
      state.purchase.wallet.bcShipmentFeeList.splice(0, state.purchase.wallet.bcShipmentFeeList.length);
      state.purchase.wallet.bcShipmentFeeList.push(...bcShipmentFeeList);
    },
    setPurchaseWalletselectWalletType(state, selectWalletType) {
      state.purchase.wallet.selectWalletType = selectWalletType;
    },
    setPurchaseWalletInputWallet(state, inputWallet) {
      state.purchase.wallet.inputWallet = inputWallet;
    },
    setPurchaseWalletShipmentFee(state, shipmentFee) {
      state.purchase.wallet.shipmentFee = shipmentFee;
    },
    setPurchaseWalletUseWalletBillAmount(state, useWalletBillAmount) {
      state.purchase.wallet.useWalletBillAmount = useWalletBillAmount;
    },


    setPurchaseTotalPrice(state, totalPrice) {
      state.purchase.totalPrice = totalPrice;
    },
    setPurchaseTotalPoint(state, totalPoint) {
      state.purchase.totalPoint = totalPoint;
    },

    setSubscriptionNowBC(state, nowBC) {
      state.subscription.nowBC = nowBC;
    },
    setSubscriptioncheckSelectRepeatOrder(state, checkSelectRepeatOrder) {
      state.subscription.checkSelectRepeatOrder = checkSelectRepeatOrder;
    },

    setSubscriptionSameWithBc001CreditCardId(state, sameWithBc001CreditCardId) {
      state.subscription.sameWithBc001CreditCardId = sameWithBc001CreditCardId;
    },
    setSubscriptionSameWithBc001CardBrand(state, sameWithBc001CardBrand) {
      state.subscription.sameWithBc001CardBrand = sameWithBc001CardBrand;
    },
    setSubscriptionSameWithBc001CardNo(state, sameWithBc001CardNo) {
      state.subscription.sameWithBc001CardNo = sameWithBc001CardNo;
    },
    setSubscriptionSameWithBc001ExpireYearMonth(state, sameWithBc001ExpireYearMonth) {
      state.subscription.sameWithBc001ExpireYearMonth = sameWithBc001ExpireYearMonth;
    },
    setSubscriptionSameWithBc001Expired(state, sameWithBc001Expired) {
      state.subscription.sameWithBc001Expired = sameWithBc001Expired;
    },
    setSubscriptionSameWithBc001HolderName(state, sameWithBc001HolderName) {
      state.subscription.sameWithBc001HolderName = sameWithBc001HolderName;
    },
    setSubscriptionSameWithBc001Selected(state, sameWithBc001Selected) {
      state.subscription.sameWithBc001Selected = sameWithBc001Selected;
    },
    setSubscriptionSameWithBc001SameWithBc001(state, sameWithBc001SameWithBc001) {
      state.subscription.sameWithBc001SameWithBc001 = sameWithBc001SameWithBc001;
    },

    setSubscriptionViewSameWithBc001(state, viewSameWithBc001) {
      state.subscription.viewSameWithBc001 = viewSameWithBc001;
    },



    setSubscriptionDeliveryAddressSameWithBc001RecipientName(state, sameWithBc001RecipientName) {
      state.subscription.deliveryAddress.sameWithBc001RecipientName = sameWithBc001RecipientName;
    },

    setSubscriptionDeliveryAddressSameWithBc001DeliveryAddressId(state, sameWithBc001DeliveryAddressId) {
      state.subscription.deliveryAddress.sameWithBc001DeliveryAddressId = sameWithBc001DeliveryAddressId;
    },

    setSubscriptionDeliveryAddressSameWithBc001ZipCode(state, sameWithBc001ZipCode) {
      state.subscription.deliveryAddress.sameWithBc001ZipCode = sameWithBc001ZipCode;
    },

    setSubscriptionDeliveryAddressSameWithBc001PrefectureName(state, sameWithBc001PrefectureName) {
      state.subscription.deliveryAddress.sameWithBc001PrefectureName = sameWithBc001PrefectureName;
    },

    setSubscriptionDeliveryAddressSameWithBc001Address(state, sameWithBc001Address) {
      state.subscription.deliveryAddress.sameWithBc001Address = sameWithBc001Address;
    },
    setSubscriptionDeliveryAddressSameWithBc001(state, sameWithBc001) {
      state.subscription.deliveryAddress.sameWithBc001 = sameWithBc001;
    },

    setSubscriptionDeliveryAddressSameWithBc001Seleced(state, sameWithBc001Seleced) {
      state.subscription.deliveryAddress.sameWithBc001Seleced = sameWithBc001Seleced;
    },

    setSubscriptionDeliveryAddressViewSameWithBc001(state, viewSameWithBc001) {
      state.subscription.deliveryAddress.viewSameWithBc001 = viewSameWithBc001;
    },

    setSubscriptionDenyCreditDeliveryFlag(state, denyCreditDeliveryFlag) {
      state.subscription.denyCreditDeliveryFlag = denyCreditDeliveryFlag;
    },


    setFanClubRedirectUrl(state, redirectUrl) {
      state.fanClub.redirectUrl = redirectUrl;
    },
    setSelectPlanList(state, planList) {
      state.fanClub.plan.selectPlanId = planList.optionContractId;
      state.fanClub.plan.selectPlanName = planList.planName;
      state.fanClub.plan.selectPlanPrice = planList.price;
    },
    setFanClubCreditCardNumber(state, cardNo) {
      state.fanClub.credit.cardNo = cardNo;
    },
    setFanClubCreditCardId(state, creditCardId) {
      state.fanClub.credit.creditCardId = creditCardId;
    },
    setFanClubOrderId(state, orderId) {
      state.fanClub.orderId = orderId;
    },

    setUserDetailDeliveryTimeDataDeliveryTimeId(state, deliveryTimeId) {
      state.userDetail.deliveryTimeData.deliveryTimeId = deliveryTimeId;
    },

    setUserDetailDeliveryTimeDataDeliveryTimeName(state, deliveryTimeName) {
      state.userDetail.deliveryTimeData.deliveryTimeName = deliveryTimeName;
    },

    setUserDetailDeliveryDateLabel(state, deliveryDateLabel) {
      state.userDetail.deliveryDate.deliveryDateLabel = deliveryDateLabel;
    },
    setUserDetailDeliveryDateValue(state, deliveryDateValue) {
      state.userDetail.deliveryDate.deliveryDateValue = deliveryDateValue;
    },


    setUserDetailDeliveryAddressDataRecipientName(state, recipientName) {
      state.userDetail.deliveryAddressData.recipientName = recipientName;
    },
    setUserDetailDeliveryAddressDataDeliveryAddressId(state, deliveryAddressId) {
      state.userDetail.deliveryAddressData.deliveryAddressId = deliveryAddressId;
    },
    setUserDetailDeliveryAddressDataZipCode(state, zipCode) {
      state.userDetail.deliveryAddressData.zipCode = zipCode;
    },
    setUserDetailDeliveryAddressDataPrefectureName(state, prefectureName) {
      state.userDetail.deliveryAddressData.prefectureName = prefectureName;
    },
    setUserDetailDeliveryAddressDataAddress(state, address) {
      state.userDetail.deliveryAddressData.address = address;
    },
    setUserDetailDeliveryAddressDataSameWithBc001(state, sameWithBc001) {
      state.userDetail.deliveryAddressData.sameWithBc001 = sameWithBc001;
    },
    setUserDetailDeliveryAddressDataSameWithBc001(state, sameWithBc001) {
      state.userDetail.deliveryAddressData.sameWithBc001 = sameWithBc001;
    },
    setUserDetailPaymentDataPaymentMethodId(state, paymentMethodId) {
      state.userDetail.paymentData.paymentMethodId = paymentMethodId;
    },
    setUserDetailPaymentDataPaymentMethodName(state, paymentMethodName) {
      state.userDetail.paymentData.paymentMethodName = paymentMethodName;
    },
    setUserDetailPaymentDataPaymentMethod(state, paymentMethod) {
      state.userDetail.paymentData.paymentMethod = paymentMethod;
    },
    setUserDetailPaymentDataPaymentExpireYearMonth(state, expireYearMonth) {
      state.userDetail.paymentData.expireYearMonth = expireYearMonth;
    },
    setUserDetailPaymentDataPaymentExpire(state, expired) {
      state.userDetail.paymentData.expired = expired;
    },
    setUserDetailPaymentDataSelectPaymentCount(state, selectPaymentCount) {
      state.userDetail.paymentData.selectPaymentCount = selectPaymentCount;
    },



    setUserDetailSelectCreditDataCardBrand(state, cardBrand) {
      state.userDetail.selectCreditData.cardBrand = cardBrand;
    },
    setUserDetailSelectCreditDataCardNo(state, cardNo) {
      state.userDetail.selectCreditData.cardNo = cardNo;
    },
    setUserDetailSelectCreditDataCreditCardId(state, creditCardId) {
      state.userDetail.selectCreditData.creditCardId = creditCardId;
    },
    setUserDetailSelectCreditDataExpireYearMonth(state, expireYearMonth) {
      state.userDetail.selectCreditData.expireYearMonth = expireYearMonth;
    },
    setUserDetailSelectCreditDataExpired(state, expired) {
      state.userDetail.selectCreditData.expired = expired;
    },
    setUserDetailSelectCreditDataHolderName(state, holderName) {
      state.userDetail.selectCreditData.holderName = holderName;
    },
    setUserDetailSelectCreditDataSelected(state, selected) {
      state.userDetail.selectCreditData.selected = selected;
    },
    setUserDetailSelectCreditDataSameWithBc001(state, sameWithBc001) {
      state.userDetail.selectCreditData.sameWithBc001 = sameWithBc001;
    },

    setUserDetailSelectCouponName(state, couponName, n) {
      state.userDetail.couponList[n].couponName = couponName;
    },
    setUserDetailSelectCouponUse(state, useCount, n) {
      state.userDetail.couponList[n].useCount = useCount;
    },

    setUserDetailCouponList(state, list) {
      state.userDetail.couponList.splice(-state.userDetail.couponList.length)
      state.userDetail.couponList.push(...list);
    },

    setUserDetailAvailableBulkSetting(state, availableBulkSetting) {
      state.userDetail.availableBulkSetting = availableBulkSetting;
    },

    setAddCreditCardReloadCheck(state, reloadCheck) {
      state.addCreditCard.reloadCheck = reloadCheck;
    },

    setArticleThumbnailList(state, articleThumbnailList) {
      state.articleList.articleThumbnailList.push(...articleThumbnailList);
    },
    setArticleCurrentPageNo(state, currentPageNo) {
      state.articleList.currentPageNo = currentPageNo;
    },
    setArticleHasNext(state, hasNext) {
      state.articleList.hasNext = hasNext
    },
    setTagArticleThumbnailList(state, tagArticleThumbnailList) {
      state.tagArticleList.articleThumbnailList.push(...tagArticleThumbnailList);
    },
    setTagArticleCurrenPagetNo(state, currentPageNo) {
      state.tagArticleList.currentPageNo = currentPageNo;
    },
    setTagArticleHasNext(state, hasNext) {
      state.tagArticleList.hasNext = hasNext;
    },
    resetTagArticleThumbnailList(state) {
      state.tagArticleList.articleThumbnailList.splice(0, state.tagArticleList.articleThumbnailList.lenth);
    },
    setArticleResultType(state, resultType) {
      state.articleResultType = resultType;
    },
    setAttentionArticleLists(state, attentionArticleLists) {
      state.attentionArticleLists = attentionArticleLists.attentionArticleList;
    },
    setCashFlowModal(state, modalShow) {
      state.wallet.cashFlow.modalShow = modalShow;
    },
    setCashFlowFromDate(state, fromDate) {
      state.wallet.cashFlow.fromDate = fromDate;
    },
    setCashFlowToDate(state, toDate) {
      state.wallet.cashFlow.toDate = toDate;
    },
    setWithdrawTotalAmount(state, totalAmount) {
      state.wallet.withdraw.totalAmount = totalAmount;
    },
    setWithdrawCashAmount(state, cashAmount) {
      state.wallet.withdraw.cashAmount = cashAmount;
    },
    setWithdrawWithdrawFee(state, withdrawFee) {
      state.wallet.withdraw.withdrawFee = withdrawFee;
    },
    setWithdrawWithdrawPrice(state, withdrawPrice) {
      state.wallet.withdraw.withdrawPrice = withdrawPrice;
    },
    setWithdrawIsBonus(state, isBonus) {
      state.wallet.withdraw.isBonus = isBonus;
    },
    setWithdrawBankAccount(state, bankAccount) {
      state.wallet.withdraw.bankAccount = bankAccount;
    },
    setWithdrawAmount(state, amount) {
      state.wallet.withdraw.amount = amount;
    },
    setSalesSummaryReportCurrentMonth(state, currentMonth) {
      state.wallet.salesSummaryReport.currentMonth = currentMonth;
    },
  },

  actions: {
    commitUserDetailDeliveryTimeData({commit}, { deliveryTimeId, deliveryTimeName }) {
      commit('setUserDetailDeliveryTimeDataDeliveryTimeId', deliveryTimeId);
      commit('setUserDetailDeliveryTimeDataDeliveryTimeName', deliveryTimeName);
    },
    commitUserDetailAvailableBulkSetting({commit}, { availableBulkSetting }) {
      commit('setUserDetailAvailableBulkSetting', availableBulkSetting);
    },
    commitUserDetailDeliveryAddressData({commit}, { recipientName, deliveryAddressId, zipCode, prefectureName, address, sameWithBc001 }) {
      commit('setUserDetailDeliveryAddressDataRecipientName', recipientName);
      commit('setUserDetailDeliveryAddressDataDeliveryAddressId', deliveryAddressId);
      commit('setUserDetailDeliveryAddressDataZipCode', zipCode);
      commit('setUserDetailDeliveryAddressDataPrefectureName', prefectureName);
      commit('setUserDetailDeliveryAddressDataAddress', address);
      commit('setUserDetailDeliveryAddressDataSameWithBc001', sameWithBc001);
    },
    commitUserDetailPaymentData({commit}, { paymentMethodId, paymentMethodName, paymentMethod }) {
      commit('setUserDetailPaymentDataPaymentMethodId', paymentMethodId);
      commit('setUserDetailPaymentDataPaymentMethodName', paymentMethodName);
      commit('setUserDetailPaymentDataPaymentMethod', paymentMethod);
    },
    commitUserDetailPaymentDataSelectPaymentCount({commit}, { selectPaymentCount }) {
      commit('setUserDetailPaymentDataSelectPaymentCount', selectPaymentCount);
    },
    commitUserDetailPaymentCredicardData({commit}, { expireYearMonth, expired }) {
      commit('setUserDetailPaymentDataPaymentExpireYearMonth', expireYearMonth);
      commit('setUserDetailPaymentDataPaymentExpire', expired);
    },
    commitUserDetailCreditData({commit}, { cardBrand, cardNo, creditCardId, expireYearMonth, expired, holderName, selected, sameWithBc001 }) {
      commit('setUserDetailSelectCreditDataCardBrand', cardBrand);
      commit('setUserDetailSelectCreditDataCardNo', cardNo);
      commit('setUserDetailSelectCreditDataCreditCardId', creditCardId);
      commit('setUserDetailSelectCreditDataExpireYearMonth', expireYearMonth);
      commit('setUserDetailSelectCreditDataExpired', expired);
      commit('setUserDetailSelectCreditDataHolderName', holderName);
      commit('setUserDetailSelectCreditDataSelected', selected);
      commit('setUserDetailSelectCreditDataSameWithBc001', sameWithBc001);
    },
    commitUserDetailCouponData({commit}, { couponName, use, n }) {
      commit('setUserDetailSelectCouponName', couponName, n);
      commit('setUserDetailSelectCouponUse', use, n);
    },
    commitCashFlowDate({commit}, {fromDate, toDate}) {
      commit('setCashFlowFromDate', fromDate);
      commit('setCashFlowToDate', toDate);
    },
    resetWithdrawData({commit}) {
      // 出金データリセット
      commit('setWithdrawTotalAmount', 0);
      commit('setWithdrawCashAmount', 0);
      commit('setWithdrawWithdrawFee', 0);
      commit('setWithdrawWithdrawPrice', null);
      commit('setWithdrawIsBonus', false);
      commit('setWithdrawBankAccount', null);
      commit('setWithdrawAmount', 0);
    },
    calcWithdrawAmount({commit}, { withdrawPrice, withdrawFee }) {
      let amount = Number(withdrawPrice) + Number(withdrawFee);
      commit('setWithdrawAmount', amount);
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js